import React from 'react';
import {
    Col, Row, Modal, FormControl, FormGroup, ControlLabel, Form
} from 'react-bootstrap';
import Select from 'react-select';
import CreatableSelect from 'react-select/lib/Creatable';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import ContactService from "../../services/ContactService";
import ProyectService from "../../services/ProyectService";
import UserService from "../../services/UserService";
import Checkbox from '../../elements/CustomCheckbox/CustomCheckbox.jsx';
import ModalBlockWrapper from '../Components/ModalBlockWrapper.jsx';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import AdministrationService from "../../services/AdministrationService";

class ModalRendicion extends React.Component {
  constructor(props) {
    super(props);
    let fecha;
    if (this.props.rendicion) {
      const dateParts = this.props.rendicion.fecha.split("/");
      fecha = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]).toISOString().split('T')[0];
    }
    this.state = {
      fecha: !this.props.rendicion ? '' : fecha,
      tipo: !this.props.rendicion ? '' : this.props.rendicion.tipo,
      numerocomprobante: !this.props.rendicion ? '' : this.props.rendicion.numerocomprobante,
      contactList: null,
      projectList: null,
      userList: null,
      condicion: !this.props.rendicion ? '' : this.props.rendicion.condicion,
      proveedor: !this.props.rendicion ? '' : this.props.rendicion.proveedor,
      concepto: !this.props.rendicion ? '' : this.props.rendicion.concepto,
      total: !this.props.rendicion ? '' : this.props.rendicion.total,
      neto: !this.props.rendicion ? '' : this.props.rendicion.neto,
      iva: !this.props.rendicion ? '' : this.props.rendicion.iva,
      proyectoid: !this.props.rendicion ? '' : this.props.rendicion.proyectoid,
      inventario: !this.props.rendicion ? '' : this.props.rendicion.inventario,
      expediente: !this.props.rendicion ? '' : this.props.rendicion.expediente,
      financia: !this.props.rendicion ? '' : this.props.rendicion.financia,
      responsable: !this.props.rendicion ? '' : this.props.rendicion.responsable,
      archivo: null,
      nombrearchivo: !this.props.rendicion ? '' : this.props.rendicion.nombrearchivo,
      rendida: !this.props.rendicion ? false : parseInt(this.props.rendicion.rendida, 10),
      id: !this.props.rendicion ? null : this.props.rendicion.id,
      error: {},
      numero: !this.props.rendicion ? null : this.props.rendicion.numero,
      fasociada: !this.props.rendicion ? '' : this.props.rendicion.fasociada,
      facturasAsociables: null,
    };
    this.administrationService = new AdministrationService();
    this.contactService = new ContactService();
    this.projectService = new ProyectService();
    this.userService = new UserService();
    this.handleFileChange = this.handleFileChange.bind(this);
    this.saveRendicion = this.saveRendicion.bind(this);
    this.clearError = this.clearError.bind(this);
  }

  componentWillMount() {
    this.contactService.getContacts()
      .then(res => {
        const contactList = res.contacts.map((item) => {
          return {value: item.id, label: `${item.apellido} ${item.nombre}`}
        });
        this.setState({contactList});
      })
      .catch(err => {
        this.props.errorAlert(
          <div>
            Ocurrio un error mientras se cargaban los datos, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>);
      });
      this.projectService.getProjectList()
        .then(res => {
          const projectList = res.data.map((proyecto) => {
            return {value: proyecto[0], label: proyecto[1]}
          });
          this.setState({projectList});
        })
        .catch(err => {
          this.props.errorAlert(
            <div>
              Ocurrio un error mientras se cargaban los datos, el servidor ha
              devuelto la siguiente información: <p>{err.message}</p>
            </div>);
        });
      this.userService.getUsers()
        .then(res => {
          const userList = res.data.map((user) => {
            return {value: user[0], label: user[1]}
          });
          this.setState({userList});
        })
        .catch(err => {
          this.props.errorAlert(
            <div>
              Ocurrio un error mientras se cargaban los datos, el servidor ha
              devuelto la siguiente información: <p>{err.message}</p>
            </div>);
        });
      this.administrationService.getFacturasAsociables()
        .then(res => {
          const facturasAsociables = res.facturasAsociables.map((item) => {
            return { value: item.numero, label: `${item.numero} - ${item.concepto}`}
          });
          console.log(facturasAsociables);
          this.setState({ facturasAsociables });
        })
        .catch(err => {
          this.props.errorAlert(
            <div>
              Ocurrio un error mientras se cargaban los datos, el servidor ha
              devuelto la siguiente información: <p>{err.message}</p>
            </div>);
        });
  }

  handleFileChange(e) {
    e.preventDefault();
    this.setState({ archivo: this.uploadInput.files[0], nombrearchivo: this.uploadInput.files[0].name });
    this.clearError('nombrearchivo');
  }

  clearError(key) {
    const auxError = { ...this.state.error };
    if (Array.isArray(key)) {
      key.forEach(field => {
        auxError[field] = false;
      });
    } else {
      auxError[key] = false;
    }
    this.setState({error: auxError});
  }

  checkErrors(rendicion) {
    const auxError = this.state.error;
    let error = false;
    Object.keys(rendicion).forEach((key) => {
      //console.log(rendicion[key])
      if (key !== 'proyectoid' && key !== 'iva' && key !== 'neto' && key !== 'rendida'
      && key !== 'id' && key !== 'expediente' && key !== 'fasociada' &&
      (!rendicion[key] || rendicion[key] === '')) {
        if (key === 'file' && !this.state.id) {
          auxError['nombrearchivo'] = !rendicion['nombrearchivo'] || rendicion['nombrearchivo'] === '';
          error = true;
        } else if (key !== 'file'){
          auxError[key] = true;
          error = true;
        }
      }
      if(key === 'expediente'){
        if(rendicion[key].length > 0 ){ // puede ser cero
          // si no lo es validar 7 digitos un guion y 2 digitos
          let test = rendicion[key];
          let pattern = new RegExp(/^\d{7}-\d{2}$/);
          //console.log(pattern.test(test));
          if(!pattern.test(test)){
            auxError[key] = true;
            error = true;
          }
        }
      }
      if (this.state.tipo && this.state.tipo !== '' &&
        this.state.tipo.label.toLowerCase().includes('recibo') && key === 'fasociada') {
        if (!rendicion[key] || rendicion[key] === '') {
          auxError[key] = true;
          error = true;
        }
      }
    });
    this.setState({error: auxError});
    return error;
  }

  saveRendicion() {
    const rendicion = {
      tipo: this.state.tipo !== '' && this.state.tipo !== null ? this.state.tipo.value : '',
      numerocomprobante: this.state.numerocomprobante,
      condicion: this.state.condicion !== '' && this.state.condicion !== null ? this.state.condicion.label : '',
      proveedor: this.state.proveedor !== '' && this.state.proveedor !== null ? this.state.proveedor.label : '',
      concepto: this.state.concepto,
      total: this.state.total,
      iva: this.state.iva,
      neto: this.state.neto,
      proyectoid: this.state.proyectoid !== '' && this.state.proyectoid !== null ? this.state.proyectoid.value : '',
      inventario: this.state.inventario !== '' && this.state.inventario !== null ? this.state.inventario.label : '',
      expediente: this.state.expediente,
      financia: this.state.financia !== '' && this.state.financia !== null ? this.state.financia.label : '',
      responsable: this.state.responsable !== '' && this.state.responsable !== null ? this.state.responsable.label : '',
      file: this.state.archivo,
      rendida: this.state.rendida ? 1 : 0,
      id: this.state.id,
      fecha: this.state.fecha,
      numero: this.state.numerocomprobante,
      nombrearchivo: this.state.nombrearchivo,
      fasociada: this.state.fasociada !== '' && this.state.fasociada !== null ? this.state.fasociada.value : '',
    };

    const error = this.checkErrors(rendicion);

    if (error) {
      this.props.errorAlert(
        <div>
          Uno o más campos contienen errores o no fueron completados!
        </div>);
    } else {
      this.props.saveRendicion(rendicion);
    }
  }

  render() {
    const condicionList = [
      {value: 0, label: 'Contado'},
      {value: 1, label: 'Cuenta Corriente'},
    ];
    const financiaList = [
      {value: 0, label: 'UNCUYO'},
      {value: 1, label: 'FUNC'},
      {value: 2, label: 'CAJA CHICA'},
      {value: 3, label: 'OTRO'},
    ];
    return (
      <Modal show onHide={() => this.props.closeModal()} style={{ display: "block" }} bsSize="large">
        <ModalBlockWrapper
          content={
            <div>
              <Modal.Header closeButton>
                <Modal.Title>{!this.state.id ? 'Nueva Rendición' : 'Editar Rendición'}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!this.state.contactList || !this.state.projectList || !this.state.userList || !this.state.facturasAsociables ?
                  <div></div> :
                  <Form horizontal>
                    <Row>
                      <Col md={6}>
                        <FormGroup validationState={this.state.error.fecha ? 'error': null}>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                            Fecha:
                          </Col>
                          <Col md={8}>
                            <FormControl
                              type="date" value={this.state.fecha}
                              onChange={(e) => this.setState({fecha: e.target.value}, this.clearError('fecha'))}
                            />
                          </Col>
                        </FormGroup>
                      </Col>
                      {this.state.tipo && this.state.tipo !== '' && this.state.tipo.label.toLowerCase().includes('recibo') &&
                        <Col md={6}>
                          <FormGroup validationState={this.state.error.fasociada ? 'error': null}>
                            <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                              Factura asociada:
                            </Col>
                            <Col md={8}>
                              <Select
                                style={{ borderColor: this.state.error.fasociada ? "#e40040" : "#aaa"}}
                                placeholder="Seleccione un comprobante"
                                closeOnSelect={true}
                                name="type"
                                value={this.state.fasociada}
                                options={this.state.facturasAsociables}
                                onChange={(value) => { this.setState({fasociada: value}, this.clearError('fasociada')) }}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                      }
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup validationState={this.state.error.tipo ? 'error': null}>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                            Tipo:
                          </Col>
                          <Col md={8}>
                            <Select
                              style={{ borderColor: this.state.error.tipo ? "#e40040" : "#aaa"}}
                              placeholder="Seleccione Tipo"
                              closeOnSelect={true}
                              name="type"
                              value={this.state.tipo}
                              options={this.props.tiposComprobantes}
                              onChange={(value) => { this.setState({tipo: value, fasociada: ''}, this.clearError(['tipo', 'fasociada'])) }}
                            />
                          </Col>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup validationState={this.state.error.numerocomprobante ? 'error': null}>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                            Nº Comprobante:
                          </Col>
                          <Col md={8}>
                            <MaskedFormControl type='text'  mask='11111-111111111111'  value={this.state.numerocomprobante}
                              onChange={(e) => this.setState({numerocomprobante: e.target.value}, this.clearError('numerocomprobante'))}
                             />
                          </Col>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup validationState={this.state.error.proveedor ? 'error': null}>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                            Proveedor:
                          </Col>
                          <Col md={8}>
                            <CreatableSelect
                              style={{ borderColor: this.state.error.proveedor ? "#e40040" : "#aaa"}}
                              isClearable
                              promptTextCreator={(label) => { return 'Agregar opción "' + label + '"'}}
                              placeholder="Seleccione Proveedor"
                              closeOnSelect={true}
                              name="type"
                              value={this.state.proveedor}
                              options={this.state.contactList}
                              onChange={(value) => { this.setState({proveedor: value}, this.clearError('proveedor')) }}
                            />
                          </Col>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup validationState={this.state.error.condicion ? 'error': null}>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                            Condición:
                          </Col>
                          <Col md={8}>
                            <Select
                              style={{ borderColor: this.state.error.condicion ? "#e40040" : "#aaa"}}
                              placeholder="Seleccione una opción"
                              closeOnSelect={true}
                              name="type"
                              value={this.state.condicion}
                              options={condicionList}
                              onChange={(value) => { this.setState({condicion: value}, this.clearError('condicion')) }}
                            />
                          </Col>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup validationState={this.state.error.concepto ? 'error': null}>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                            Concepto:
                          </Col>
                          <Col md={8}>
                            <FormControl
                              type="text" value={this.state.concepto}
                              onChange={(e) => this.setState({concepto: e.target.value}, this.clearError('concepto'))}
                            />
                          </Col>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup validationState={this.state.error.total ? 'error': null}>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                            Total:
                          </Col>
                          <Col md={8}>
                            <FormControl
                              type="number" value={this.state.total}
                              onChange={(e) => this.setState({total: e.target.value}, this.clearError('total'))}
                            />
                          </Col>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup validationState={this.state.error.neto ? 'error': null}>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                            Neto:
                          </Col>
                          <Col md={8}>
                            <FormControl
                              type="number" value={this.state.neto}
                              onChange={(e) => this.setState({neto: e.target.value}, this.clearError('neto'))}
                            />
                          </Col>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup validationState={this.state.error.iva ? 'error': null}>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                            IVA:
                          </Col>
                          <Col md={8}>
                            <FormControl
                              type="number" value={this.state.iva}
                              onChange={(e) => this.setState({iva: e.target.value}, this.clearError('iva'))}
                            />
                          </Col>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup validationState={this.state.error.proyectoid ? 'error': null}>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                            Proyecto:
                          </Col>
                          <Col md={8}>
                            <Select
                              style={{ borderColor: this.state.error.proyectoid ? "#e40040" : "#aaa"}}
                              placeholder="Seleccione un Proyecto"
                              closeOnSelect={true}
                              name="type"
                              value={this.state.proyectoid}
                              options={this.state.projectList}
                              onChange={(value) => { this.setState({proyectoid: value}, this.clearError('proyectoid')) }}
                            />
                          </Col>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup validationState={this.state.error.inventario ? 'error': null}>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                            Inventario:
                          </Col>
                          <Col md={8}>
                            <Select
                              style={{ borderColor: this.state.error.inventario ? "#e40040" : "#aaa"}}
                              placeholder="Seleccione una opción"
                              closeOnSelect={true}
                              name="type"
                              value={this.state.inventario}
                              options={[{value: 0, label: 'Si'}, {value: 1, label: 'No'}]}
                              onChange={(value) => { this.setState({inventario: value}, this.clearError('inventario')) }}
                            />
                          </Col>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup validationState={this.state.error.expediente ? 'error': null}>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                            Expediente:
                          </Col>
                          <Col md={8}>
                            <MaskedFormControl mask='1111111-11'
                              type="text" value={this.state.expediente}
                              onChange={(e) => this.setState({expediente: e.target.value}, this.clearError('expediente'))}
                            />
                          </Col>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup validationState={this.state.error.financia ? 'error': null}>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                            Financia:
                          </Col>
                          <Col md={8}>
                            <Select
                              style={{ borderColor: this.state.error.financia ? "#e40040" : "#aaa"}}
                              placeholder="Seleccione una opción"
                              closeOnSelect={true}
                              name="type"
                              value={this.state.financia}
                              options={financiaList}
                              onChange={(value) => { this.setState({financia: value}, this.clearError('financia')) }}
                            />
                          </Col>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup validationState={this.state.error.responsable ? 'error': null}>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                            Responsable:
                          </Col>
                          <Col md={8}>
                            <Select
                              style={{ borderColor: this.state.error.responsable ? "#e40040" : "#aaa"}}
                              placeholder="Seleccione un usuario"
                              closeOnSelect={true}
                              name="type"
                              value={this.state.responsable}
                              options={this.state.userList}
                              onChange={(value) => { this.setState({responsable: value}, this.clearError('responsable')) }}
                            />
                          </Col>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup validationState={this.state.error.nombrearchivo ? 'error': null}>
                          <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                            Archivo:
                          </Col>
                          <Col md={8}>
                            <FormControl
                              type="text" value={this.state.nombrearchivo ? this.state.nombrearchivo : 'No se seleccionó ningún archivo..'}
                              disabled
                            />
                          </Col>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <span style={{ float: 'left' }}>
                          <input ref={(ref) => { this.uploadInput = ref; }} type="file" style={{'visibility': 'hidden'}} onChange={this.handleFileChange} />
                        </span>
                      </Col>
                      <Col md={6}>
                        <span style={{ float: 'right' }}>
                          <Button onClick={() => this.uploadInput.click()} bsStyle="primary" fill={true}>Seleccionar archivo</Button>
                          <Button disabled={!this.state.archivo && !this.state.nombrearchivo} onClick={() => this.setState({ archivo: null, nombrearchivo: null })} bsStyle="danger" fill={true}>
                            <i className="fa fa-ban"></i>
                          </Button>
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} style={{textAlign: 'center'}}>
                        <Checkbox
                          label={'Rendida'}
                          number={'rendida'}
                          isChecked={this.state.rendida}
                          handleOnChange={(e) => this.setState({ rendida: e })}
                        />
                      </Col>
                    </Row>
                  </Form>
                }
              </Modal.Body>
              <Modal.Footer>
                <Button simple onClick={this.props.closeModal}>
                  Cancelar
                </Button>
                <Button
                  bsStyle="success" fill onClick={this.saveRendicion}
                >
                  Guardar
                </Button>
              </Modal.Footer>
            </div>
          }
        />
      </Modal>
    );
  }
}

export default ModalRendicion;



// WEBPACK FOOTER //
// ./src/views/Administration/ModalRendicion.jsx